// components/Inputs/DescriptionVisibleInput/DescriptionVisibleInput.js
import { Switch } from 'antd'

function DescriptionVisibleInput({ value, onChange }) {
  const handleChange = (checked) => {
    onChange(checked)
  }

  return <Switch checked={value} onChange={handleChange} />
}

export default DescriptionVisibleInput
